export const internal = /^\/(?!\/)/;

export const email = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const temp = null;
